(function () {
	angular
		.module('trackeye')
		.factory('GenericLogger', _GenericLoggerFactory);

	_GenericLoggerFactory.$inject = [];

	function _GenericLoggerFactory() {

		/**
		 * @constructor
		 * @param {Error} e
		 */
		function Generic(e) {
			this.debug = false;
			this.silent = false;
			this.level = 'err';
			this.message = e.error.stack;
		}

		Generic.prototype.isSilent = function () {
			return this.silent;
		};

		Generic.prototype.getLevel = function () {
			return this.level;
		};

		Generic.prototype.getMessage = function () {
			return this.message;
		};

		Generic.prototype.getMessageId = function () {
			return 'GENERIC_FRONTEND_ERROR';
		};

		Generic.prototype.getData = function () {
			return undefined;
		};

		Generic.prototype.getXhr = function () {
			return undefined;
		};

		Generic.prototype.getNoticeType = function () {
			return "warning";
		};

		Generic.prototype.getNoticeMessage = function () {
			return "STR_ERROR_NOTICE_GENERIC_FRONTEND_ERROR";
		};

		Generic.prototype.getTranslateValues = function () {
			return {};
		};

		return Generic;
	}
})();